import { useSyncExternalStore } from 'react';

import { Invoice, InvoiceDraft } from './types';

/**
 * Invoices created during this demo session, plus the New Invoice form's in-progress draft. Kept at
 * module scope rather than in component state so they survive leaving /bookkeeping/invoicing and
 * coming back; like the bookkeeping mocks' state, a hard reload resets them.
 */
interface InvoicingSession {
    created: Invoice[];
    draft: InvoiceDraft | null;
}

let session: InvoicingSession = { created: [], draft: null };
const listeners = new Set<() => void>();

function update(next: Partial<InvoicingSession>) {
    session = { ...session, ...next };
    listeners.forEach((listener) => listener());
}

function subscribe(listener: () => void) {
    listeners.add(listener);
    return () => {
        listeners.delete(listener);
    };
}

export function useInvoicingSession(): InvoicingSession {
    return useSyncExternalStore(subscribe, () => session);
}

export const saveDraft = (draft: InvoiceDraft) => update({ draft });

export const clearDraft = () => update({ draft: null });

export const addInvoice = (invoice: Invoice) => update({ created: [invoice, ...session.created], draft: null });
